import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
} from "reactstrap";



import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
// import { FetchModificarCarrito,limpiarDatosValidacionesPlaca } from "../../../redux/actions/ACarritoProductos";
// import { setConsultaPlaca} from "../../../redux/actions/aCotizacion";

class CardResumenUbicacion extends React.Component {
  constructor(props) {
    super(props);

  }

  onEditar = (e) => {
    e.preventDefault()
    if (this.props.datosItem.totales && this.props.datosItem.totales !== undefined && this.props.datosItem.totales !== null) {
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso4",
        search: `?recuperar=true&codEdicion=${this.props.datosItem.codigo}`

      });
    }
    else {
      this.redireccionarPasoUbicacion();
    }
  }

  redireccionarPasoUbicacion() {
    if (this.props.datosCarritoHogar.leadUltimosPasosPorItem && this.props.datosCarritoHogar.leadUltimosPasosPorItem !== undefined && this.props.datosCarritoHogar.leadUltimosPasosPorItem !== null) {
      //Obtener Producto actual
      let ObtenerProductoActual = this.props.datosCarritoHogar.leadUltimosPasosPorItem.filter((item) =>
        item.codigo === this.props.datosItem.codigo
      )
      ObtenerProductoActual = ObtenerProductoActual[0];

      //Obtener Paso Actual
      let pathActual = '';
      if (ObtenerProductoActual.paso === "inicioUbicacion") {
        pathActual = `/cotizacion-hogar-paso2`
      }
      else if (ObtenerProductoActual.paso === "seleccionConstruccion") {
        pathActual = `/cotizacion-hogar-paso3`
      }
      else if (ObtenerProductoActual.paso === "protecciones") {
        pathActual = `/cotizacion-hogar-paso4`
      }
      //Redireccionar 
      this.props.history.push({
        pathname: pathActual,
        search: `codEdicion=${this.props.datosItem.codigo}`, //agregar parametros de la url,
      });
    }
  }


  onEliminar = (e) => {
    e.preventDefault()
    let { datosItem } = this.props;
    this.props.metodoEliminar(datosItem.codigo)
  }

  render() {
    let { datosItem, indice, esAdvance } = this.props;
    console.log('datos', datosItem.totales)
    console.log('datosItem', datosItem)
    indice = parseInt(indice) + 1;
    return (

      <Card className="flex-row ">
        <CardBody>
          <h4 style={{ fontWeight: "bold" }}> {`Ubicación del Bien Asegurado #  ${indice}`}</h4>
          <p></p>
          <Row>
            <Col lg={4} md={4} sm={4} xs={12}>
              <h5 style={{ fontWeight: "bold" }}>Provincia</h5>
            </Col>
            <Col lg={8} md={8} sm={8} xs={12}>
              {(datosItem.datosUbicacion.provincia && datosItem.datosUbicacion.provincia.label ? datosItem.datosUbicacion.provincia.label : "")}
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={4} xs={12}>
              <h5 style={{ fontWeight: "bold" }}>Ciudad</h5>
            </Col>
            <Col lg={8} md={4} sm={4} xs={12}>
              {(datosItem.datosUbicacion.ciudad && datosItem.datosUbicacion.ciudad.label ? datosItem.datosUbicacion.ciudad.label : "")}
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={4} sm={4} xs={12}>
              <h5 style={{ fontWeight: "bold" }}>Dirección del Bien Asegurado</h5>
            </Col>
            <Col lg={8} md={8} sm={8} xs={12}>
              {(datosItem.datosUbicacion && datosItem.datosUbicacion.direccion ? datosItem.datosUbicacion.direccion : "")}
            </Col>
          </Row>

          {datosItem.planContenidos && datosItem.planContenidos.primaCobertura &&
            <Row>
              <Col lg={4} md={4} sm={4} xs={12}>
                <h5 style={{ fontWeight: "bold" }}>Plan Contenidos</h5>
              </Col>
              <Col lg={8} md={8} sm={8} xs={12}>
                ${(datosItem.planContenidos && datosItem.planContenidos.primaCobertura[0] ? parseFloat(datosItem.planContenidos.primaCobertura[6].valor).toFixed(2) : "")}
              </Col>
            </Row>
          }

          {datosItem.planEstructura && datosItem.planEstructura.primaCobertura &&
            <Row>
              <Col lg={4} md={4} sm={4} xs={12}>
                <h5 style={{ fontWeight: "bold" }}>Plan Estructura</h5>
              </Col>
              <Col lg={8} md={8} sm={8} xs={12}>
                ${(datosItem.planEstructura && datosItem.planEstructura.primaCobertura[0] ? parseFloat(datosItem.planEstructura.primaCobertura[6].valor).toFixed(2) : "")}
              </Col>
            </Row>
          }
          <Row>
            <Col lg={4} md={4} sm={4} xs={12}>
              <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
            </Col>

            {datosItem.totales && datosItem.totales.primaTotal ?
              <Col lg={8} md={4} sm={4} xs={12}>
                $ {(datosItem.totales && datosItem.totales.primaTotal ? datosItem.totales.primaTotal : "0")}
              </Col> : datosItem.totales && datosItem.totales.totalcarrito ?

                <Col lg={8} md={4} sm={4} xs={12}>
                  $ {(datosItem.totales && datosItem.totales.totalcarrito ? datosItem.totales.totalcarrito : "0")}
                </Col>

                : datosItem.totales && datosItem.totales.primaTotal_Full_Cobertura ?
                  <Col lg={8} md={4} sm={4} xs={12}>
                    $ {(datosItem.totales && datosItem.totales.primaTotal_Full_Cobertura ? datosItem.totales.primaTotal_Full_Cobertura : "0")}
                  </Col> : null
            }




          </Row>

          <div>
            <Row>
              <div className="div-align-rigth">
                <Button className="btn btn-detail-gray" onClick={this.onEditar}>
                  <i className="fa fa-pencil-square-o" aria-hidden="true" />{" "}
                  EDITAR
                </Button>
                &nbsp;&nbsp;
                <Button className="btn btn-detail-white" onClick={this.onEliminar}>
                  <i className="fa fa-trash-o" aria-hidden="true" /> ELIMINAR
                </Button>
              </div>
            </Row>

          </div>



        </CardBody>
      </Card>

    );
  }
}

const mapStateToProps = state => ({
  datosCarritoHogar: state.datosCarritoHogar.setCarritoHogar,
});

const mapDispatchToProps = dispatch => {
  return {
    // eliminarProducto: data => dispatch(FetchModificarCarrito(data)),
    // setDatosPlaca:(datos)=> dispatch(setConsultaPlaca(datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CardResumenUbicacion)
);
